import React from 'react';
import { Link } from "react-router-dom";
import { Menu } from 'antd';
import Logo from '../assets/icons/logo_mad.png';
import { DownOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons';
import './less/Nav.less';

import BANNER from '../assets/images/banner.jpg';


const { SubMenu } = Menu;

class Header extends React.Component {

  constructor(props) {

    super(props);
    if (window.innerWidth > 768) {
      this.state = {
        mode: 'horizontal',
        current: '',
        show: true,
        theposition: window.pageYOffset
      };
    } else {
      this.state = {
        mode: "inline",
        current: '',
        show: false,
        theposition: window.pageYOffset
      };
    }
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.handleScroll);
  };

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = (event) => {
    if (window.pageYOffset < 100) {
      this.setState({
        navShadow: false
      });
    } else {
      this.setState({
        navShadow: true
      });
    }
  };

  handleClick = e => {
    this.setState({ current: e.key });
  };

  toggleMenu = () => {
    this.setState({ show: !this.state.show });
  }

  render() {
    const { current } = this.state;
    const { mode } = this.state;
    const { show } = this.state;
    const { navShadow } = this.state;
    
    const menuStyle = {
      opacity: show ? 1 : 0,
      visibility: show ? 'visible' : 'hidden',
      zIndex: show ? 999 : -1,
      transition: "all 160ms ease-in"
    };

    const menuShadow = {
      boxShadow: navShadow ? '0 10px 20px 0 rgba(9,30,66,.08)': 'none'
    }

    let menu = (
      <Menu onClick={this.handleClick} style={menuStyle} selectedKeys={[current]} mode={mode}>

        <Menu.Item key="logo" selectable={false}>

        </Menu.Item>

        <SubMenu
          key="app"
          title="سامانه مدیریت هوشمند"
          icon={<DownOutlined />}

        >
          <Menu.ItemGroup title="سامانه">
            <Menu.Item key="app:1">
              <Link href="/school-app" to="/school-app">
                معرفی سامانه
              </Link>
            </Menu.Item>
            {/* <Menu.Item key="app:2">
              دموی سامانه
            </Menu.Item> */}
            <Menu.Item key="app:3">
              <a href="https://panel.madtalk.ir">ورود به سامانه</a>
            </Menu.Item>
            <Menu.Item key="app:1">
              <Link href="/app-page" to="/app-page">
                دانلود اپلیکیشن
              </Link>
            </Menu.Item>
          </Menu.ItemGroup>

          {/* <Menu.ItemGroup title="راهنما">
            <Menu.Item key="app:4">
              راهنمای خرید
            </Menu.Item>
            <Menu.Item key="app:5">
              آموزش نرم افزار
            </Menu.Item>
          </Menu.ItemGroup> */}
        </SubMenu>

        <SubMenu
          key="onlineClass"
          title="کلاس آنلاین"
          icon={<DownOutlined />}

        >
          <Menu.ItemGroup title="نرم افزار">
            <Menu.Item key="onlineClass:1">
              <Link href="/online-class" to="/online-class">
                معرفی نرم افزار
              </Link>
            </Menu.Item>
            <Menu.Item key="onlineClass:2">
              <Link href="/online-class/plans" to="/online-class/plans">
                تعرفه ها
              </Link>
            </Menu.Item>
            {/* <Menu.Item key="onlineClass:3">
              دمو
            </Menu.Item> */}
          </Menu.ItemGroup>
          {/* <Menu.ItemGroup title="راهنما">
            <Menu.Item key="onlineClass:5">
              راهنمای خرید
            </Menu.Item>
            <Menu.Item key="onlineClass:6">
              آموزش نرم افزار
            </Menu.Item>
          </Menu.ItemGroup> */}
        </SubMenu>



        <Menu.Item key="blog">
          <a href="https://blog.madtalk.ir/">
            بلاگ
          </a>
        </Menu.Item>
        <Menu.Item key="aboutus">
          <Link href="/about" to="/about">
            درباره ما
          </Link>
        </Menu.Item>
        <Menu.Item key="contactus">
          <Link href="/contact" to="/contact">
            تماس با ما
          </Link>
        </Menu.Item>



        {/* <SubMenu
          key="more"
          title="بیشتر"
          icon={<DownOutlined />}
        >
          <Menu.Item key="more:2">
            <Link href="/status" to="/status">
              <span>وضعیت سرویس ها</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="more:3">
            <Link href="/rules" to="/rules">
              <span>قوانین و مقررات</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="more:4">
            <Link href="/privacy-policy" to="/privacy-policy">
              <span>حریم خصوصی</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="more:5">
            <Link href="/customers" to="/customers">
              <span>مشتری ها</span>
            </Link>
          </Menu.Item>
        </SubMenu> */}

        <Menu.Item key="login">
          <div className="btn-row btn-row-mobile">
            <a href="https://panel.madtalk.ir/" className="ant-btn">
              <span>
                ورود | عضویت
            </span>
              <small>(پنل مدیران)</small>
            </a>
          </div>
        </Menu.Item>
      </Menu>
    )

    return (
      <div className="ant-row ant-row-rtl menu-row" style={menuShadow}>
        <div className="banner">
          <a href="https://panel.madtalk.ir/auth/register" style={{backgroundImage:`url(${BANNER})`}}></a>
        </div>
        <div className="logo">
          <Link href="/" to="/">
            <img src={Logo} alt="مدتاک" />
          </Link>
        </div>

        <div className="menu-icon">

          <span onClick={this.toggleMenu}>
            {show &&
              <CloseOutlined />
            }
            {!show &&
              <MenuOutlined />
            }
          </span>

        </div>
        {
          menu
        }

        <div className="btn-row">
          <a href="https://panel.madtalk.ir/" className="ant-btn">
            <span>
              ورود | عضویت
            </span>
            <small>(پنل مدیران)</small>
          </a>
        </div>
      </div>

    );
  }
}

export default Header;
